import React, { Component } from 'react';

import { buildPath } from '../utils/route_utils';
import { trackEvent } from '../utils/analytics';
import { observeRise } from '../utils/reveal';
import '../css/NiroSection.css';

/*
 * "Introducing NIRO" — full-bleed band on the home page.
 * One idea, stated once: the brain in every Nexuni robot, and the loop it
 * runs. Abstract flow-field background (public/assets/niro/niro_field.*),
 * generated in-house; no product collage, no datasheet strip.
 */

const LANGS = ['zh', 'en', 'ja'];
const CORE_ROUTE = '/core-technology';

const COPY = {
  headline: {
    zh: 'NIRO: 機器人的AI大腦',
    en: 'NIRO: The AI brain for robots',
    ja: 'NIRO: ロボットのAI頭脳'
  },
  lede: {
    zh: 'Nexuni 的機器人與自動化系統都由AI大腦驅動，我們致力於透過NIRO打造聰明、進場就能上工的具身智慧勞動力。',
    en: 'Every Nexuni robot and automation system runs on an AI brain. Through NIRO, we build a smart, ready-to-work embodied AI workforce.',
    ja: 'Nexuni のロボットと自動化システムは、すべて AI の頭脳で動いています。私たちは NIRO を通じて、賢く、現場に入ればすぐ働けるエンボディド AI のワークフォースをつくります。'
  },
  loopLabel: { zh: 'NIRO 迴圈', en: 'The NIRO loop', ja: 'NIRO ループ' },
  loop: [
    { zh: '感知', en: 'Perceive', ja: '感知' },
    { zh: '規劃', en: 'Plan', ja: '計画' },
    { zh: '執行', en: 'Act', ja: '実行' },
    { zh: '驗證', en: 'Verify', ja: '検証' },
    { zh: '恢復', en: 'Recover', ja: '復旧' },
    { zh: '學習', en: 'Learn', ja: '学習' }
  ],
  cta: { zh: '深入了解核心技術', en: 'Explore the core technology', ja: 'コア技術を詳しく見る' }
};

class NiroSection extends Component {
  constructor(props) {
    super(props);
    this.rootRef = React.createRef();
    this.go = this.go.bind(this);
  }

  componentDidMount() {
    this.disposeRise = observeRise(this.rootRef.current);
  }

  componentWillUnmount() {
    if (this.disposeRise) this.disposeRise();
  }

  lang() {
    return LANGS.includes(this.props.lang) ? this.props.lang : 'en';
  }

  // Real <a href>: modified clicks open the link in a new tab.
  go(e, route) {
    if (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
      e.preventDefault();
    }
    trackEvent('select_brain', { location: 'home_niro' });
    if (typeof this.props.navigate === 'function') {
      this.props.navigate(route);
    } else {
      window.location.href = buildPath(this.lang(), route);
    }
  }

  render() {
    const lang = this.lang();
    const t = (o) => o[lang];

    return (
      <section className="niro-section" ref={this.rootRef} aria-labelledby="niro-title">
        <picture className="niro-bg" aria-hidden="true">
          <source media="(max-width: 780px)" srcSet="/assets/niro/niro_field_m.webp" type="image/webp" />
          <source srcSet="/assets/niro/niro_field.webp" type="image/webp" />
          <img src="/assets/niro/niro_field.jpg" alt="" width="2560" height="1440" loading="lazy" decoding="async" />
        </picture>
        <span className="niro-scrim" aria-hidden="true"></span>

        <div className="niro-inner bleed">
          <h2 id="niro-title" className="h-display niro-title rise">{t(COPY.headline)}</h2>
          <p className="p-lede niro-lede rise">{t(COPY.lede)}</p>

          <div className="niro-loop rise" role="group" aria-label={t(COPY.loopLabel)}>
            <span className="niro-loop-label">{t(COPY.loopLabel)}</span>
            <ol className="niro-loop-row">
              {COPY.loop.map((step) => (
                <li key={step.en}>{t(step)}</li>
              ))}
            </ol>
          </div>

          <div className="niro-actions rise">
            <a className="btn-primary" href={buildPath(lang, CORE_ROUTE)} onClick={(e) => this.go(e, CORE_ROUTE)}>
              {t(COPY.cta)}
              <span className="arrow" aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </section>
    );
  }
}

export default NiroSection;
